import React from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';
import { map, isEmpty } from 'lodash';

import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';

const VideoCoordinatesDataSourceField = ({
  coordinatesDataType,
  toggleButtonSwitch,
  changeCoordinatesDataType,
  isAutoLoadData,
  dataLoaded
}) => {
  let showElements = false;
  if (!isAutoLoadData) showElements = true;
  else showElements = false;

  if (dataLoaded && isEmpty(coordinatesDataType)) showElements = true;

  return (
    <>
      {showElements && (
        <>
          <Row style={{ mb: '0px', maxHeight: '40px' }}>
            <Col style={{ mb: '0px', height: '30px' }}>
              <Form.Label>Coordinates Data Source</Form.Label>
            </Col>
          </Row>
          <Form.Group>
            <Form.Control
              as="select"
              name="coordinatesDataType"
              value={coordinatesDataType}
              onFocus={() => toggleButtonSwitch()}
              onChange={changeCoordinatesDataType}
            >
              <option key="" value="">
                -
              </option>
              {map(VIDEO_COORDINATE_DATA_TYPES.properties, ({ value, humanValue }) => (
                <option value={value} key={value}>
                  {humanValue}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </>
      )}
    </>
  );
};

VideoCoordinatesDataSourceField.defaultProps = {
  dataLoaded: false
};

VideoCoordinatesDataSourceField.propTypes = {
  coordinatesDataType: PropTypes.string.isRequired,
  toggleButtonSwitch: PropTypes.func.isRequired,
  changeCoordinatesDataType: PropTypes.func.isRequired,
  isAutoLoadData: PropTypes.bool.isRequired,
  dataLoaded: PropTypes.bool
};

export default VideoCoordinatesDataSourceField;
